import { LinkRule, NodeCategory } from "./ah.mb.link-validator";

    export class DefaultLinkRules {

        static getRules(): Array<LinkRule> {

            const rules = new Array<LinkRule>();

            // Alloc rules
            rules.push(new LinkRule("Hub", NodeCategory.Alloc, 1, -1, 1, -1, true));
            rules.push(new LinkRule("Annual_Clearing_Hub", NodeCategory.Alloc, 1, -1, 1, -1, true));
            rules.push(new LinkRule("External_Price", NodeCategory.Alloc, 0, 0, 1, -1, true));

            // Non-alloc rules
            rules.push(new LinkRule("Link_Splitter", NodeCategory.NonAlloc, 1, 1, 1, -1, true));
            rules.push(new LinkRule("Demand", NodeCategory.NonAlloc, 1, 1, 0, 0, true));
            rules.push(new LinkRule("Resource", NodeCategory.NonAlloc, 0, 0, 1, 1, true));
            rules.push(new LinkRule("Simple_Supply", NodeCategory.NonAlloc, 0, 0, 1, 1, true));
            rules.push(new LinkRule("Transportation", NodeCategory.NonAlloc, 1, -1, 1, 1, true));
            rules.push(new LinkRule("Refining", NodeCategory.NonAlloc, 1, -1, 1, -1, false));
            rules.push(new LinkRule("Conversion", NodeCategory.NonAlloc, 1, -1, 1, 1, true));
            rules.push(new LinkRule("Electric", NodeCategory.NonAlloc, 1, -1, 1, 1, true));
            rules.push(new LinkRule("Upper_Bound", NodeCategory.NonAlloc, 1, -1, 1, 1, true));
            rules.push(new LinkRule("Discrete_Choice", NodeCategory.NonAlloc, 1, -1, 1, 1, true));
            rules.push(new LinkRule("Storage", NodeCategory.NonAlloc, 1, 1, 1, 1, true));
            rules.push(new LinkRule("NonLinearStorage", NodeCategory.NonAlloc, 1, 1, 1, 1, true));

            rules.push(new LinkRule("CE_Supply", NodeCategory.NonAlloc, 0, 0, 1, 1, true));
            rules.push(new LinkRule("GroupNode", NodeCategory.NonAlloc, 0, 0, 0, 0, true));

            return rules;

        }
    }



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.default-link-rules.ts